export default {
  isPrimary: true,
  color: 'primary',
  size: 'medium',
  text: '',
  disabled: false,
  fullWidth: false,
  href: undefined,
};
